/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import '../../index-6f6b9acc.js';
import { a as loadScriptsByOrder } from '../../loadscripts-cf212b8d.js';
import { E as ErrorCodes, B as BRIDGE_DEPEND_LIBS } from '../../constants-163bd007.js';
import { a as adapterApiCall, n as noop } from '../../bridge-adpter-api-0316c034.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../tslib.es6-e01eabb2.js';

var JSCall = function () {
    var _a, _b;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], _c = args[2], success = _c === void 0 ? noop : _c, _d = args[3], failure = _d === void 0 ? noop : _d;
    var apiFunc = window.tpPlus.runBridgeFunction;
    try {
        (_b = (_a = apiFunc(apiName, params)) === null || _a === void 0 ? void 0 : _a.then(success)) === null || _b === void 0 ? void 0 : _b.catch(failure);
    }
    catch (e) {
        console.error(e);
        failure(e);
    }
};
/**
 * 老盘古端容器桥接
 * @param api
 * @param params
 * @param formatOptions
 * @param errFormatOptions
 */
function PanguMiniAppCall() {
    /** 钉钉方法名 */
    var args = [];
    for (
    /** 钉钉方法名 */
    var _i = 0; 
    /** 钉钉方法名 */
    _i < arguments.length; 
    /** 钉钉方法名 */
    _i++) {
        /** 钉钉方法名 */
        args[_i] = arguments[_i];
    }
    var apiName = args[0], params = args[1], successFormatOptions = args[2], errFormatOptions = args[3];
    // 按需加载
    loadPanguMiniAppDependLibs()
        .then(function () {
        adapterApiCall({
            apiName: apiName,
            params: params,
            JSCall: JSCall,
            successFormatOptions: successFormatOptions,
            errFormatOptions: errFormatOptions,
        });
    })
        .catch(function () {
        var _a;
        (_a = params === null || params === void 0 ? void 0 : params.fail) === null || _a === void 0 ? void 0 : _a.call(params, {
            errCode: ErrorCodes.DependError,
            errMsg: 'pangu lib script not download',
        });
    });
}
/**
 * 依赖加载
 */
var loadPanguMiniAppDependLibs = function () {
    return new Promise(function (resolve, reject) {
        if (typeof window.tpPlus === 'undefined') {
            loadScriptsByOrder(BRIDGE_DEPEND_LIBS.panguMiniApp)
                .then(resolve)
                .catch(reject);
        }
        else {
            resolve(window.tpPlus);
        }
    });
};

export { JSCall, PanguMiniAppCall, loadPanguMiniAppDependLibs };
